import { render, staticRenderFns } from "./NotificationSettingTable.vue?vue&type=template&id=ac30a948&scoped=true&lang=pug"
import script from "./NotificationSettingTable.vue?vue&type=script&lang=ts"
export * from "./NotificationSettingTable.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSettingTable.vue?vue&type=style&index=0&id=ac30a948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac30a948",
  null
  
)

export default component.exports